import { localStorageAvailable } from '@utils/localStorage';

export const CLX_VERSION_OVERRIDE_KEY = 'qa_clx_version_override';

export const getClxVersionOverride = () => {
  if (typeof window === 'undefined' || !localStorageAvailable()) return '';
  return (localStorage.getItem(CLX_VERSION_OVERRIDE_KEY) || '').trim();
};

export const setClxVersionOverride = (version) => {
  if (typeof window === 'undefined' || !localStorageAvailable()) return false;
  const normalized = String(version || '').trim();
  if (!/^\d+$/.test(normalized)) return false;
  localStorage.setItem(CLX_VERSION_OVERRIDE_KEY, normalized);
  return true;
};

export const clearClxVersionOverride = () => {
  if (typeof window === 'undefined' || !localStorageAvailable()) return;
  localStorage.removeItem(CLX_VERSION_OVERRIDE_KEY);
};
